import axios from "axios";
import { API_BASE_URL, API_ROOT } from "../../../../../../../Helpers/apiConfig";

const HandlePhotoChange = async (data, token, setImagePath, setMsg) => {
    const url = API_BASE_URL + "/admin/ContentFile/UploadFile";

    const headerss = {
        "accept": "*/*",
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
    }

    try {
        const res = await axios({
            method: 'Post',
            url: url,
            params: { mediaType: "photo" },
            data: data,
            headers: headerss
        });

        if (res.status === 200 && res.data.success) {
            setImagePath(API_ROOT + "/" + res.data.data.path);
            return true;
        }

        setMsg(res.data?.message || "Yükleme başarısız.");
        return false;

    } catch (err) {
        setMsg(err.message);
        return false;
    }
}

export default HandlePhotoChange;